package com.downdogapp.client.controllers.playback

import com.downdogapp.*
import com.downdogapp.client.MANIFEST
import com.downdogapp.client.api.OfflineUrlRequest
import com.downdogapp.client.api.PlaybackUrlRequest
import com.downdogapp.client.api.Sequence
import com.downdogapp.client.singleton.*

object PlaybackUtil {

  fun playbackUrlRequest(sequence: Sequence,
                         playlistId: String?,
                         videoOffsetTime: Duration,
                         airplay: Boolean) =
    PlaybackUrlRequest(
      sequenceId = sequence.sequenceId,
      playlistId = playlistId,
      videoOffsetTime = videoOffsetTime,
      audioBalance = audioBalance,
      includeCountdown = showCountdown,
      includeOverlay = showOverlay,
      includePoseNames = displayPoseNames,
      includeClosedCaptions = showSubtitles,
      mirrorVideo = mirrorVideo,
      videoQualityId = videoQualityId,
      cellularConnection = Network.usingCellularConnection(),
      chromecast = Cast.isCasting,
      airplay = airplay
    )

  fun offlineUrlRequest(sequenceId: String,
                        playlistId: String?) =
    OfflineUrlRequest(
      sequenceId = sequenceId,
      playlistId = playlistId,
      audioBalance = audioBalance,
      includeCountdown = showCountdown,
      includeOverlay = showOverlay,
      includePoseNames = displayPoseNames,
      includeClosedCaptions = showSubtitles,
      mirrorVideo = mirrorVideo,
      videoQualityId = videoQualityId,
    )

  var audioBalance: Double
    get() = UserPrefs[Key.AudioBalance] ?: MANIFEST.defaultAudioBalance
    set(value) {
      UserPrefs[Key.AudioBalance] = value
    }

  var displayPoseNames: Boolean
    get() = UserPrefs[Key.DisplayPoseNames] ?: MANIFEST.defaultDisplayPoseNames
    set(value) {
      UserPrefs[Key.DisplayPoseNames] = value
    }

  var showLikeAndExcludeButtons: Boolean
    get() = UserPrefs[Key.showLikeAndExcludeButtons] ?: MANIFEST.defaultShowLikeAndExcludeButtons
    set(value) {
      UserPrefs[Key.showLikeAndExcludeButtons] = value
    }

  var showSubtitles: Boolean
    get() = UserPrefs[Key.ShowSubtitles] ?: MANIFEST.defaultShowSubtitles
    set(value) {
      UserPrefs[Key.ShowSubtitles] = value
    }

  var showCountdown: Boolean
    get() = UserPrefs[Key.ShowCountdown] ?: MANIFEST.defaultShowCountdown
    set(value) {
      UserPrefs[Key.ShowCountdown] = value
    }

  var showOverlay: Boolean
    get() = UserPrefs[Key.ShowOverlay] ?: MANIFEST.defaultShowOverlay
    set(value) {
      UserPrefs[Key.ShowOverlay] = value
    }

  var keepTimelineVisible: Boolean
    get() = UserPrefs[Key.KeepTimelineVisible] ?: MANIFEST.defaultKeepTimelineVisible
    set(value) {
      UserPrefs[Key.KeepTimelineVisible] = value
    }

  var showPosesOnTimeline: Boolean
    get() = UserPrefs[Key.ShowPosesOnTimeline] ?: true
    set(value) {
      UserPrefs[Key.ShowPosesOnTimeline] = value
    }

  var mirrorVideo: Boolean
    get() = UserPrefs[Key.MirrorVideo] ?: false
    set(value) {
      UserPrefs[Key.MirrorVideo] = value
    }

  var videoQualityId: Int
    get() = UserPrefs[Key.VideoQualityId]
              ?.let { storedId ->
                if (MANIFEST.videoQualities.any { it.id == storedId }) storedId else null
              }
            ?: MANIFEST.defaultVideoQualityId
    set(value) {
      UserPrefs[Key.VideoQualityId] = value
    }
}
